import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import * as AuthActions from '../actions/Auth';
import SignForm from '../components/SignForm';

// componentのsignFormとの連係
const selector = formValueSelector('signForm');

const mapStateToProps = (state: any) => {
  const username = selector(state, 'username');
  const password = selector(state, 'password');
  return {
    auth: state.auth,
    signForm: {
      username,
      password,
    }
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignForm as any);



// WEBPACK FOOTER //
// ./src/containers/SignForm.tsx